import { getCookie } from './cookies';

export const getGCLIDValue = () => {
  let gclidValues: any = Array.of(getCookie('gclid_1'), getCookie('gclid_2'), getCookie('gclid_3')).filter(
    (cookie) => cookie !== null
  );

  gclidValues = gclidValues.length ? gclidValues.join('.') : '';

  return gclidValues;
};
